import React from "react";
import { GKLoadingType, GKLoading } from "@granular/gds-ux-components";

export const Loading: React.FC = () => {
  return (
    <GKLoading
      isLoading
      overlay
      type={GKLoadingType.Spinner}
      className="h-100"
    />
  );
};
